module.exports = __webpack_public_path__ + "img/pump-10.1a9a60fe.svg";